import { createApi } from '@reduxjs/toolkit/query/react';
import { VALUATION_DATES_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import { ValuationDatesResponse } from 'services/types';

export const valuationDatesApi = createApi({
  reducerPath: VALUATION_DATES_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getValuationDatesByContext: builder.query<ValuationDatesResponse[], string>(
      {
        query: (context) => encodeURI(`/contexts/${context}/valuationDates`),
      }
    ),
  }),
});

export const { useGetValuationDatesByContextQuery } = valuationDatesApi;
